"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("@mui/material"),o=t.styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`,n=t.styled(t.IconButton)(({theme:e})=>({"&.MuiIconButton-root":{"&:hover":{backgroundColor:e.palette.primary[75]}}}));exports.StyledIconButton=n;exports.Wrapper=o;
